import { AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE, AUTH_CODE_ERROR_LENGTH_OR_TYPE } from 'common/constants/login';

export const constraints = {
  otp: {
    length: { minimum: 6, message: AUTH_CODE_ERROR_LENGTH_OR_TYPE },
    format: {
      pattern: /^\d{6}/,
      message: AUTH_CODE_ERROR_LENGTH_OR_TYPE,
    },
  },
};

export const constraintsBkCode = {
  backupCode: {
    length: { minimum: 8, message: AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE, maximum: 8 },
    format: {
      pattern: /^[a-zA-Z2-9]{8}/,
      message: AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE,
    },
  },
};
